import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../../3rdPartyModules/_react-aria/utils/dist/mergeProps-DMtmc2Zw.js';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { f as focusOutline } from '../../FocusIndicator/styleMixins/focusOutline-DNwtedBp.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const activeStyles = /*#__PURE__*/css(["border-color:", ";background-color:", ";font-weight:bold;a,p{font-weight:normal;}"], ({
  theme
}) => theme.button.toggle.borderColorActive, ({
  theme
}) => theme.button.toggle.bgActive);
const normalStyles = /*#__PURE__*/css(["border-color:", ";background-color:", ";:hover{background:", ";}"], ({
  theme
}) => theme.button.toggle.borderColor, ({
  theme
}) => theme.button.toggle.bg, ({
  theme
}) => theme.button.toggle.bgHover);
const StyledToggleButton = /*#__PURE__*/styled('button').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    $focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1vzueig-0"
})(["", ";padding:", " 18px;border-radius:", ";border:1px solid ", ";color:", ";cursor:", ";text-align:center;vertical-align:middle;user-select:auto;@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms ease;}", " ", " :focus{outline:none;", "}:disabled{pointer-events:all;cursor:not-allowed;outline:none;opacity:1;color:", ";:hover{background:", ";}}"], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.button.normal.paddingV, ({
  theme
}) => theme.button.toggle.borderRadius, ({
  theme
}) => theme.button.borderColor, ({
  theme
}) => theme.button.toggle.color, ({
  theme
}) => theme.button.cursor, isMobile(css(["padding:", " 18px;font-size:", ";"], ({
  theme
}) => theme.button.normal.mobile.paddingV, ({
  theme
}) => theme.button.normal.mobile.fontSize)), ({
  $active
}) => $active ? activeStyles : normalStyles, ({
  $focusVisible
}) => $focusVisible && focusOutline, ({
  theme
}) => theme.typography.color.tertiary, ({
  theme,
  $active
}) => $active ? theme.button.toggle.bgActive : theme.button.toggle.bg);
StyledToggleButton.displayName = 'StyledToggleButton';

/* SSR workaround for nodejs, things like HTMLButtonElement dont exists in nodejs. */
const NodeSafeHTMLButtonElement = typeof HTMLButtonElement !== 'undefined' ? HTMLButtonElement : Object;
class ToggleButton extends PureComponent {
  render() {
    const {
      active,
      disabled,
      type,
      buttonRef,
      taktId,
      taktValue,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('toggle-button')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement(StyledToggleButton, _extends({}, getDataTaktAttributes(), rest, {
      ref: buttonRef,
      $active: active,
      role: "switch",
      "aria-checked": active,
      disabled: disabled,
      type: type
    })));
  }
}
_defineProperty(ToggleButton, "propTypes", {
  active: PT.bool,
  disabled: PT.bool,
  type: PT.oneOf(['submit', 'reset', 'button']),
  buttonRef: PT.oneOfType([PT.func, PT.shape({
    current: PT.instanceOf(NodeSafeHTMLButtonElement)
  })])
});
_defineProperty(ToggleButton, "defaultProps", {
  active: false,
  disabled: false,
  type: 'button',
  buttonRef: undefined
});

export { ToggleButton as T };
//# sourceMappingURL=ToggleButton-CCRdiyS2.js.map
